export default {
      id: "sli-notif-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#sli-notif",
      toString: function () {
        return this.url;
      }
    }